import React from 'react';
import { connect } from 'formik';
import cn from 'classnames';
import { injectIntl } from 'react-intl';

import InputField from '../../components/forms/input.field.js';
import CheckboxField from '../../components/forms/checkbox.field.js';
import RadioField from '../../components/forms/radio.field.js';

import PhoneInput from '../../components/forms/phone-number-input.field.js';
import SelectField from '../../components/forms/select.field.js';

import './customer-details.step.scss';

const CustomerDetailsStep = ({
	privacyAndPolicyPDF,
	formik: {
		values, errors, touched, setFieldValue, setFieldTouched,
	}, intl,
}) => (
	<div className="customer-details row">
		<div className="col-xs-12">
			<div className="container">
				<h3>
					{intl.formatMessage({
						id: 'checkout.customer-details.customer-details',
					})}
				</h3>

				<div className="row">
					<div className="col-xs-12 col-sm-6 field-input">
						<InputField
							error={errors.firstName}
							touched={touched.firstName}
							name="firstName"
							placeholder={intl.formatMessage({ id: 'formik.name' })}
						/>
					</div>
					<div className="col-xs-12 col-sm-6 field-input">
						<InputField
							error={errors.lastName}
							touched={touched.lastName}
							name="lastName"
							placeholder={intl.formatMessage({ id: 'formik.surname' })}
						/>
					</div>
				</div>

				<div className="row">
					<div className="col-xs field-input">
						<InputField
							error={errors.email}
							touched={touched.email}
							name="email"
							placeholder={intl.formatMessage({ id: 'formik.email' })}
						/>
					</div>
				</div>

				<div className="row">
					<div className="col-xs-12 col-sm-6 field-input">
						<PhoneInput
							onChange={phone => setFieldValue('phone', phone)}
							onBlur={() => setFieldTouched('phone')}
							name="phone"
							value={values.phone}
							validationMessage={errors.phone}
							error={errors.phone && touched.phone}
							placeholder={intl.formatMessage({ id: 'formik.phone' })}
						/>
					</div>
				</div>

				<div className="row">
					<div className="col-xs">
						<CheckboxField
							name="addBillingAddress"
							checked={values.addBillingAddress}
						>
							{intl.formatMessage({
								id: 'checkout.customer-details.add-billing-address',
							})}
						</CheckboxField>
					</div>
				</div>

				{values.addBillingAddress && (
					<div
						className={cn('billing-info', { active: values.addBillingAddress })}
					>
						<div className="row">
							<div className="col-xs-12 col-sm-6 field-input">
								<SelectField
									error={errors.country}
									touched={touched.country}
									name="country"
									placeholder={intl.formatMessage({ id: 'formik.country' })}
									setFieldValue={setFieldValue}
									selectedValue={values.country}
								/>
							</div>
							<div className="col-xs-12 col-sm-6 field-input">
								<InputField
									error={errors.vatNumber}
									touched={touched.vatNumber}
									name="vatNumber"
									placeholder={intl.formatMessage({ id: 'formik.nif' })}
									disabled={!values.country}
								/>
							</div>
						</div>

						<div className="row">
							<div className="col-xs-12 field-input">
								<InputField
									error={errors.address}
									touched={touched.address}
									name="address"
									placeholder={intl.formatMessage({ id: 'formik.address' })}
								/>
							</div>
						</div>

						<div className="row">
							<div className="col-xs-12 col-sm-6 field-input">
								<InputField
									error={errors.postalCode}
									touched={touched.postalCode}
									name="postalCode"
									placeholder={intl.formatMessage({ id: 'formik.postal-code' })}
								/>
							</div>
							<div className="col-xs-12 col-sm-6 field-input">
								<InputField
									error={errors.city}
									touched={touched.city}
									name="city"
									placeholder={intl.formatMessage({ id: 'formik.city' })}
								/>
							</div>
						</div>
					</div>
				)}

				<div className="ticket-receiving-method">
					<h3>
						{intl.formatMessage({
							id: 'checkout.customer-details.ticket-receiving-method',
						})}
					</h3>

					<ul className="radio-group">
						<li
							className={cn('radio-option', {
								active: values.selectedMethod === 'email',
							})}
						>
							<RadioField
								name="selectedMethod"
								value="email"
								checked={values.selectedMethod === 'email'}
								label={intl.formatMessage({ id: 'formik.email' })}
								extraLabel={intl.formatMessage({ id: 'formik.free' })}
							/>
						</li>
						<li
							className={cn('radio-option', {
								active: values.selectedMethod === 'email+sms',
							})}
						>
							<RadioField
								name="selectedMethod"
								value="email+sms"
								checked={values.selectedMethod === 'email+sms'}
								label={intl.formatMessage({ id: 'formik.email-more-ticket' })}
								extraLabel="€2 Eur"
							/>
						</li>
					</ul>

					<div className="row">
						<div className="col-xs field-input">
							<CheckboxField
								name="acceptPrivacyPolicy"
								checked={values.acceptPrivacyPolicy}
							>
								{intl.formatMessage({
									id: 'checkout.customer-details.i-have-read-and-accept',
								})}
								<a
									target="new window"
									href={`${process.env.REACT_APP_API_ENDPOINT}/${privacyAndPolicyPDF}`}
								>
									{intl.formatMessage({
										id: 'checkout.customer-details.privacy-policy',
									})}
								</a>
							</CheckboxField>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
);

export default injectIntl(connect(CustomerDetailsStep));
